import { AbstractControl } from '@angular/forms';

/**
 * Cross-validates duplicate email controls
 */
export function updateDuplicateEmailErrors(emailControls: AbstractControl[]): void {
    const emails = emailControls.map((emailControl) => (emailControl.value as string | undefined)?.toLowerCase() ?? '');
    const counts = new Map<string, number>();
    for (const email of emails) {
        if (email) counts.set(email, (counts.get(email) ?? 0) + 1);
    }
    emailControls.forEach((emailControl) => {
        const email = (emailControl.value as string | undefined)?.toLowerCase() ?? '';
        if (email && (counts.get(email) ?? 0) > 1) {
            emailControl.setErrors({ ...(emailControl.errors ?? {}), duplicateEmail: true });
        } else if (emailControl.hasError('duplicateEmail')) {
            const { duplicateEmail: _, ...rest } = emailControl.errors ?? {};
            emailControl.setErrors(Object.keys(rest).length ? rest : null);
        }
    });
}
